import React from 'react';
import Select from 'react-select';
import { STATE_OPTIONS, ACCOUNT_TYPE_OPTIONS, getSelectStyles } from '../constants';

/**
 * Bank icon SVG component
 */
const BankIcon = ({ selected }) => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`payment-icon ${selected ? ' selected' : ''}`}
  >
    <path d="M0 6.31546V10.5268H1.05258V16.8412H0V19.9989H16.8412L19.9989 20L21.0515 19.9989V16.8412H19.9989V10.5268H21.0515V6.31546L10.5258 0L0 6.31546ZM4.21031 16.8412V10.5268H6.31546V16.8412H4.21031ZM9.47319 16.8412V10.5268H11.5783V16.8412H9.47319ZM16.8412 16.8412H14.7361V10.5268H16.8412V16.8412ZM12.6309 6.31546C12.6308 6.59198 12.5763 6.86578 12.4704 7.12123C12.3645 7.37667 12.2094 7.60876 12.0138 7.80424C11.8182 7.99972 11.5861 8.15477 11.3306 8.26053C11.0751 8.36628 10.8012 8.42068 10.5247 8.42061C10.2482 8.42054 9.97439 8.36601 9.71894 8.26012C9.4635 8.15424 9.23141 7.99908 9.03592 7.8035C8.84044 7.60792 8.6854 7.37575 8.57964 7.12025C8.47389 6.86475 8.41949 6.59093 8.41956 6.3144C8.4197 5.75594 8.64168 5.22041 9.03667 4.82562C9.43166 4.43083 9.9673 4.20911 10.5258 4.20925C11.0842 4.20939 11.6198 4.43137 12.0145 4.82636C12.4093 5.22135 12.6311 5.757 12.6309 6.31546Z" />
  </svg>
);

/**
 * Card icon SVG component
 */
const CardIcon = ({ selected }) => (
  <svg
    width="27"
    height="21"
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`payment-icon ${selected ? ' selected' : ''}`}
  >
    <path d="M0.00101471 5.29174H26.1123V4.18576C26.1123 1.73687 24.8643 0.5 22.3789 0.5H3.73446C1.24956 0.5 0.000507415 1.73687 0.000507415 4.18627L0.00101471 5.29174ZM0.00101471 16.8259C0.00101471 19.2753 1.24905 20.5 3.73446 20.5H22.3789C24.8638 20.5 26.1128 19.2753 26.1128 16.8259V7.99125H0L0.00101471 16.8259ZM3.9724 13.9245V11.7247C3.9724 11.0591 4.4361 10.5832 5.13774 10.5832H8.05083C8.75247 10.5832 9.21617 11.0591 9.21617 11.7247V13.9245C9.21617 14.6023 8.75247 15.066 8.05083 15.066H5.13723C4.43559 15.066 3.9724 14.6023 3.9724 13.9245Z" />
  </svg>
);

/**
 * CVV icon SVG component
 */
const CvvIcon = () => (
  <svg width="30" height="20" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" fill="#FFF" role="img" aria-labelledby="cvcDesc">
    <g opacity="0.74">
      <path fillRule="evenodd" clipRule="evenodd" d="M25.2061 0.00488281C27.3194 0.112115 29 1.85996 29 4V11.3291C28.5428 11.0304 28.0336 10.8304 27.5 10.7188V8H1.5V16C1.5 17.3807 2.61929 18.5 4 18.5H10.1104V20H4L3.79395 19.9951C1.7488 19.8913 0.108652 18.2512 0.00488281 16.2061L0 16V4C0 1.85996 1.68056 0.112115 3.79395 0.00488281L4 0H25L25.2061 0.00488281ZM4 1.5C2.61929 1.5 1.5 2.61929 1.5 4V5H27.5V4C27.5 2.61929 26.3807 1.5 25 1.5H4Z" />
      <path d="M27.5 12.7988C28.3058 13.1128 28.7725 13.7946 28.7725 14.6406C28.7722 15.4002 28.2721 15.9399 27.6523 16.1699C28.1601 16.3319 28.6072 16.6732 28.8086 17.2207C28.3597 18.6222 27.1605 19.6862 25.6826 19.9404C24.8389 19.7707 24.1662 19.2842 23.834 18.5H25C25.0914 18.5 25.1816 18.4939 25.2705 18.4844C25.5434 18.7862 25.9284 18.9501 26.3623 18.9502C27.142 18.9501 27.6922 18.5297 27.6924 17.79C27.6923 17.4212 27.5473 17.1544 27.2998 16.9795C27.4281 16.6786 27.5 16.3478 27.5 16V15.0527C27.5397 14.9481 27.5625 14.8309 27.5625 14.7002C27.5625 14.5657 27.5399 14.4422 27.5 14.3311V12.7988Z" />
      <path d="M15.2207 18.5V18.8301H16.8799V19.9004H12.1104V18.8301H13.9902V18.5H15.2207Z" />
      <path d="M19.9307 18.5L19.5762 18.7803H22.8369V19.9004H17.8164V18.8604L18.2549 18.5H19.9307Z" />
    </g>
    <path d="M26.3822 20.01C24.9722 20.01 23.8522 19.25 23.6422 17.81L24.8722 17.58C24.9922 18.45 25.6022 18.95 26.3622 18.95C27.1422 18.95 27.6922 18.53 27.6922 17.79C27.6922 17.05 27.1122 16.72 26.2822 16.72H25.5722V15.67H26.3022C27.0622 15.67 27.5622 15.34 27.5622 14.7C27.5622 14.07 27.1022 13.68 26.3922 13.68C25.6422 13.68 25.1322 14.18 24.9822 14.92L23.8122 14.76C24.0022 13.55 24.9822 12.61 26.4322 12.61C27.8822 12.61 28.7722 13.47 28.7722 14.64C28.7722 15.4 28.2722 15.94 27.6522 16.17C28.3422 16.39 28.9222 16.94 28.9222 17.89C28.9222 19.04 27.9522 20.01 26.3822 20.01Z" />
    <path d="M17.8161 18.86L19.6161 17.38C20.5961 16.58 21.4761 15.87 21.4761 14.97C21.4761 14.23 21.0161 13.7 20.2561 13.7C19.5061 13.7 19.0161 14.29 19.0161 15C19.0161 15.23 19.0561 15.46 19.1361 15.68H17.9461C17.8461 15.39 17.8161 15.2 17.8161 14.93C17.8161 13.58 18.9261 12.61 20.2861 12.61C21.7861 12.61 22.7461 13.54 22.7461 14.89C22.7461 16.16 21.7861 17.03 20.7761 17.83L19.5761 18.78H22.8361V19.9H17.8161V18.86Z" />
    <path d="M14.25 12.67H15.22V18.83H16.88V19.9H12.11V18.83H13.99V14.92H12.15V13.99L12.88 13.93C13.78 13.86 14.18 13.58 14.25 12.67Z" />
  </svg>
);

/**
 * Payment method selection buttons
 */
const PaymentMethodSelector = ({ paymentMethod, onSelect }) => (
  <fieldset className="payment-method-fieldset">
    <legend className="sr-only">Payment method selection</legend>
    <div id="payment-method-group" className="plan-selection payment-method-selection" role="radiogroup" aria-labelledby="payment-method-group">
      {/* Bank Account Option */}
      <div
        className={`plan-option payment-method ${paymentMethod === 'bank' ? 'selected' : ''}`}
        onClick={() => onSelect('bank')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect('bank');
          }
        }}
        tabIndex={0}
        role="radio"
        aria-checked={paymentMethod === 'bank'}
        aria-label="Bank account payment method"
      >
        <input
          type="radio"
          name="paymentMethod"
          value="bank"
          checked={paymentMethod === 'bank'}
          onChange={() => onSelect('bank')}
          style={{ display: 'none' }}
          aria-hidden="true"
        />
        <BankIcon selected={paymentMethod === 'bank'} />
        <span>Bank account</span>
      </div>

      {/* Credit Card Option */}
      <div
        className={`plan-option payment-method ${paymentMethod === 'card' ? 'selected' : ''}`}
        onClick={() => onSelect('card')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect('card');
          }
        }}
        tabIndex={0}
        role="radio"
        aria-checked={paymentMethod === 'card'}
        aria-label="Credit card payment method"
      >
        <input
          type="radio"
          name="paymentMethod"
          value="card"
          checked={paymentMethod === 'card'}
          onChange={() => onSelect('card')}
          style={{ display: 'none' }}
          aria-hidden="true"
        />
        <CardIcon selected={paymentMethod === 'card'} />
        <span>Credit card</span>
      </div>
    </div>
  </fieldset>
);

/**
 * Billing address fields (shared between card and bank)
 */
const BillingAddressFields = ({
  paymentMethod,
  cardFirstName,
  cardLastName,
  billingAddress,
  billingCity,
  billingState,
  billingZip,
  nameOnAccount,
  handleFieldChange,
  errors
}) => (
  <div className="form-grid mt-4">
    {/* Name on Card/Account */}
    <div className="form-group full-width">
      <div className="name-inputs">
        <div>
          <label htmlFor="first-name-card" className="mb-2 block">
            {paymentMethod === 'card' ? 'First name on card' : 'First name on account'}
          </label>
          <div className="form-group-input-container flex">
            <input
              type="text"
              id="first-name-card"
              data-recurly="first_name"
              value={cardFirstName}
              onChange={(e) => handleFieldChange('cardFirstName', e.target.value)}
              autoComplete="given-name"
              className="font-mono w-100"
            />
          </div>
        </div>
        <div>
          <label htmlFor="last-name-card" className="mb-2 block">
            {paymentMethod === 'card' ? 'Last name on card' : 'Last name on account'}
          </label>
          <div className="form-group-input-container flex">
            <input
              type="text"
              id="last-name-card"
              data-recurly="last_name"
              value={cardLastName}
              onChange={(e) => handleFieldChange('cardLastName', e.target.value)}
              autoComplete="family-name"
              className="font-mono w-100"
            />
          </div>
        </div>
        <input
          type="hidden"
          data-recurly="name_on_account"
          value={nameOnAccount}
        />
      </div>
      {(errors.cardFirstName || errors.cardLastName) && (
        <span className="error">{errors.cardFirstName || errors.cardLastName}</span>
      )}
    </div>

    {/* Billing Address */}
    <div className="form-group">
      <label htmlFor="billing-address">
        {paymentMethod === 'card' ? 'Billing street address' : 'Street address'}
      </label>
      <div className="form-group-input-container flex">
        <input
          type="text"
          id="billing-address"
          data-recurly="address1"
          value={billingAddress}
          onChange={(e) => handleFieldChange('billingAddress', e.target.value)}
          autoComplete="address-line1"
          className="font-mono w-100"
        />
      </div>
      {errors.billingAddress && <span className="error">{errors.billingAddress}</span>}
    </div>

    {/* Billing City */}
    <div className="form-group">
      <label htmlFor="billing-city">
        {paymentMethod === 'card' ? 'Billing city' : 'City'}
      </label>
      <div className="form-group-input-container flex">
        <input
          type="text"
          id="billing-city"
          data-recurly="city"
          value={billingCity}
          onChange={(e) => handleFieldChange('billingCity', e.target.value)}
          autoComplete="address-level2"
          className="font-mono w-100"
        />
      </div>
      {errors.billingCity && <span className="error">{errors.billingCity}</span>}
    </div>

    {/* Billing State */}
    <div className="form-group">
      <label htmlFor="billing-state">
        {paymentMethod === 'card' ? 'Billing state' : 'State'}
      </label>
      <Select
        id="billing-state"
        inputId="billing-state"
        placeholder="Select a state…"
        options={STATE_OPTIONS}
        value={STATE_OPTIONS.find(option => option.value === billingState) || null}
        onChange={option => handleFieldChange('billingState', option ? option.value : '')}
        isSearchable
        classNamePrefix="react-select"
        styles={getSelectStyles(68)}
      />
      {errors.billingState && <span className="error">{errors.billingState}</span>}
    </div>

    {/* Billing Zip */}
    <div className="form-group">
      <label htmlFor="billing-zip">
        {paymentMethod === 'card' ? 'Billing zip code' : 'Zip code'}
      </label>
      <div className="form-group-input-container flex">
        <input
          type="text"
          id="billing-zip"
          data-recurly="postal_code"
          value={billingZip}
          onChange={(e) => handleFieldChange('billingZip', e.target.value)}
          autoComplete="postal-code"
          className="font-mono w-100"
        />
      </div>
      {errors.billingZip && <span className="error">{errors.billingZip}</span>}
    </div>

    {/* Hidden fields for Recurly */}
    <input
      type="hidden"
      id="billing-state-hidden"
      data-recurly="state"
      value={billingState}
      autoComplete="state"
    />
    <input
      type="hidden"
      id="billing-country"
      data-recurly="country"
      value="US"
      autoComplete="country"
    />
  </div>
);

/**
 * Credit card specific fields (Recurly hosted fields)
 */
const CreditCardFields = () => (
  <>
    <div className="form-group full-width mt-4">
      <label htmlFor="card-number">Card number &#128274;</label>
      <div id="recurly-card-number">
        {/* Recurly.js will mount the card number element here */}
      </div>
    </div>
    <div className="form-group flex-row mt-4">
      <div className="exp-field">
        <label htmlFor="recurly-card-month">Exp. Month (MM)</label>
        <div id="recurly-card-month" className="recurly-element-inline">
          {/* Recurly.js will mount the card month element here */}
        </div>
      </div>
      <div className="exp-field">
        <label htmlFor="recurly-card-year">Exp. Year (YYYY)</label>
        <div id="recurly-card-year" className="recurly-element-inline">
          {/* Recurly.js will mount the card year element here */}
        </div>
      </div>
      <div className="exp-field">
        <label htmlFor="recurly-card-cvv">Security Code</label>
        <div id="recurly-card-cvv" className="recurly-element-inline">
          {/* Recurly.js will mount the card CVV element here */}
        </div>
        <div className="exp-field-icon">
          <CvvIcon />
        </div>
      </div>
    </div>
  </>
);

/**
 * Bank account specific fields
 */
const BankAccountFields = ({
  accountType,
  routingNumber,
  accountNumber,
  accountNumberConfirmation,
  nameOnAccount,
  handleFieldChange,
  errors
}) => (
  <>
    {/* Account Type */}
    <div className="form-group mt-4">
      <label htmlFor="recurly-account-type">Account type</label>
      <Select
        id="recurly-account-type"
        inputId="recurly-account-type"
        placeholder="Select account type…"
        options={ACCOUNT_TYPE_OPTIONS}
        value={ACCOUNT_TYPE_OPTIONS.find(option => option.value === accountType) || null}
        onChange={option => handleFieldChange('accountType', option.value)}
        isSearchable={false}
        classNamePrefix="react-select"
        styles={getSelectStyles(68)}
      />
      <input
        type="hidden"
        data-recurly="account_type"
        value={accountType}
      />
      {errors.accountType && <span className="error">{errors.accountType}</span>}
    </div>

    {/* Routing Number */}
    <div className="form-group">
      <label htmlFor="recurly-routing-number">Routing number</label>
      <div className="form-group-input-container flex">
        <input
          id="recurly-routing-number"
          data-recurly="routing_number"
          value={routingNumber}
          onChange={(e) => handleFieldChange('routingNumber', e.target.value)}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={9}
          autoComplete="off"
          className="font-mono w-100"
        />
      </div>
      {errors.routingNumber && <span className="error">{errors.routingNumber}</span>}
    </div>

    {/* Account Number */}
    <div className="form-group">
      <label htmlFor="recurly-account-number">Bank account number</label>
      <div className="form-group-input-container flex">
        <input
          id="recurly-account-number"
          data-recurly="account_number"
          value={accountNumber}
          onChange={(e) => handleFieldChange('accountNumber', e.target.value)}
          type="text"
          autoComplete="off"
          className="font-mono w-100"
        />
      </div>
      {errors.accountNumber && <span className="error">{errors.accountNumber}</span>}
    </div>

    {/* Confirm Account Number */}
    <div className="form-group">
      <label htmlFor="account-number-confirmation">Confirm account number</label>
      <div className="form-group-input-container flex">
        <input
          data-recurly="account_number_confirmation"
          value={accountNumberConfirmation}
          onChange={(e) => handleFieldChange('accountNumberConfirmation', e.target.value)}
          autoComplete="off"
          type="text"
          className="font-mono w-100"
        />
      </div>
      {errors.accountNumberConfirmation && <span className="error">{errors.accountNumberConfirmation}</span>}
    </div>

    <input
      type="hidden"
      data-recurly="name_on_account"
      value={nameOnAccount}
    />
  </>
);

/**
 * Main PaymentDetailsSection component
 */
const PaymentDetailsSection = ({
  paymentMethod,
  cardFirstName,
  cardLastName,
  billingAddress,
  billingCity,
  billingState,
  billingZip,
  nameOnAccount,
  accountType,
  routingNumber,
  accountNumber,
  accountNumberConfirmation,
  handleFieldChange,
  errors
}) => (
  <fieldset className="form-section-single-fieldset">
    <div className="form-section-single-legend-container">
      <legend className="form-section-single-legend">Your payment details</legend>
    </div>

    <PaymentMethodSelector
      paymentMethod={paymentMethod}
      onSelect={(method) => handleFieldChange('paymentMethod', method)}
    />

    <BillingAddressFields
      paymentMethod={paymentMethod}
      cardFirstName={cardFirstName}
      cardLastName={cardLastName}
      billingAddress={billingAddress}
      billingCity={billingCity}
      billingState={billingState}
      billingZip={billingZip}
      nameOnAccount={nameOnAccount}
      handleFieldChange={handleFieldChange}
      errors={errors}
    />

    {paymentMethod === 'card' && <CreditCardFields />}

    {paymentMethod === 'bank' && (
      <BankAccountFields
        accountType={accountType}
        routingNumber={routingNumber}
        accountNumber={accountNumber}
        accountNumberConfirmation={accountNumberConfirmation}
        nameOnAccount={nameOnAccount}
        handleFieldChange={handleFieldChange}
        errors={errors}
      />
    )}

    <input type="hidden" data-recurly="token" />
  </fieldset>
);

export default PaymentDetailsSection;
